import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { CrudService } from '../../../../core';
import { PacoteCampanha } from '../pacote-campanha';

@Injectable({
    providedIn: 'root'
})
export class PacoteCampanhaCrudHttpService {
    resource = 'pacoteCampanha';

    constructor(private crudService: CrudService) { }

    /** Procura um único pacote de campanha através do seu ID */
    find(id: number): Observable<PacoteCampanha> {
        return this.crudService.find<PacoteCampanha>(this.resource, id);
    }

    /** Carrega um único pacote de campanha através do seu ID */
    load(id: number): Observable<PacoteCampanha> {
        return this.crudService.load<PacoteCampanha>(this.resource, id);
    }

    /** Insere um novo pacote de campanha */
    insert(entity: PacoteCampanha): Observable<PacoteCampanha> {
        return this.crudService.insert<PacoteCampanha>(this.resource, entity);
    }

    /** Altera uma pacote de campanha existente */
    update(entity: PacoteCampanha): Observable<PacoteCampanha> {
        return this.crudService.update<PacoteCampanha>(this.resource, entity);
    }

    /** Exclui uma pacote de campanha através do seu ID */
    delete(id: number): Observable<string> {
        return this.crudService.delete(this.resource, id);
    }
}
